// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'clipboard-plus';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M11.808 3.384h2.808c.288 0 .576.144.792.36s.36.504.36.792v11.808c0 .288-.144.576-.36.792s-.504.36-.792.36H3.384c-.288 0-.576-.144-.792-.36s-.36-.504-.36-.792V4.464c0-.288.144-.576.36-.792s.504-.36.792-.36h2.808c0-.72.288-1.44.792-2.016C7.488.792 8.208.504 9 .504s1.44.288 2.016.792c.504.648.792 1.368.792 2.088z' />
    <path d='M9 3.384c-.144 0-.288-.144-.288-.288s.144-.288.288-.288m0 .576c.144 0 .288-.144.288-.288S9.144 2.808 9 2.808m2.808 8.136H6.192M9 8.136v5.616' />
  </g>
);

export const viewBox = '0 0 18 18';
